import React, { useState, useEffect, useMemo } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Link, useNavigate } from "react-router-dom";
import { 
  Card, 
  Table, 
  Row, 
  Col, 
  Form, 
  InputGroup, 
  Button, 
  Pagination, 

  Badge, 
  Modal, 
  Alert, 
  Spinner, 
  Toast, 
  ToastContainer,
  ProgressBar,
  
  ListGroup
} from "react-bootstrap";
import {
  CreditCard,
  Wallet,
  Bank,
  Cash,
//   Phone,
  QrCode,
  Building,
  CheckCircle,
  XCircle,
  ExclamationCircle,
  InfoCircle,
  Search,
  ArrowLeft,
  PlusCircle,
  Trash,
  Pencil,
  Eye,
  Download,
  ChevronDown,
  ChevronUp,
  X,
  
  Clock,
  Percent,
  Activity,
  
  ShieldCheck,
  CreditCardFill,
 
//   BankFill,
  CashStack,
  Phone,
  Globe,
  
  Check,

} from "react-bootstrap-icons";

// Import des bibliothèques d'export
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';

// Données de démo pour les moyens de paiement
const demoPaymentMethods = [
  {
    id: 1,
    code: "CB_VISA",
    nom: "Carte VISA",
    type: "carte",
    categorie: "électronique",
    statut: "actif",
    commission: 2.5,
    delaiReglement: 2,
    fraisFixe: 500,
    seuilMinimum: 1000,
    seuilMaximum: 5000000,
    disponibilite: ["en_ligne", "guichet", "mobile"],
    tauxSuccess: 98.5,
    volumeMensuel: 1250000000,
    nombreTransactions: 45200,
    description: "Carte bancaire VISA acceptée dans tous les points de vente",
    dateCreation: "2023-01-15T09:00:00Z",
    dateModification: "2023-11-01T14:30:00Z",
    conditions: [
      "Présentation de la carte physique",
      "Code PIN requis",
      "Limite de sécurité selon la banque émettrice"
    ],
    fournisseur: "VISA International",
    contactFournisseur: "contact@visa.com",
    integration: {
      apiDisponible: true,
      documentation: "https://developer.visa.com",
      support24h: true
    }
  },
  {
    id: 2,
    code: "CB_MASTERCARD",
    nom: "Carte Mastercard",
    type: "carte",
    categorie: "électronique",
    statut: "actif",
    commission: 2.3,
    delaiReglement: 2,
    fraisFixe: 500,
    seuilMinimum: 1000,
    seuilMaximum: 5000000,
    disponibilite: ["en_ligne", "guichet", "mobile"],
    tauxSuccess: 97.8,
    volumeMensuel: 980000000,
    nombreTransactions: 32500,
    description: "Carte bancaire Mastercard avec technologie de sécurité avancée",
    dateCreation: "2023-01-20T10:15:00Z",
    dateModification: "2023-10-15T11:20:00Z",
    conditions: [
      "Authentification 3D Secure",
      "Limite par transaction configurable"
    ],
    fournisseur: "Mastercard Worldwide",
    contactFournisseur: "support@mastercard.com",
    integration: {
      apiDisponible: true,
      documentation: "https://developer.mastercard.com",
      support24h: true
    }
  },
  {
    id: 3,
    code: "ORANGE_MONEY",
    nom: "Orange Money",
    type: "mobile",
    categorie: "mobile",
    statut: "actif",
    commission: 1.8,
    delaiReglement: 1,
    fraisFixe: 100,
    seuilMinimum: 100,
    seuilMaximum: 1000000,
    disponibilite: ["mobile", "en_ligne"],
    tauxSuccess: 99.2,
    volumeMensuel: 750000000,
    nombreTransactions: 185000,
    description: "Service de paiement mobile par Orange",
    dateCreation: "2023-02-10T08:45:00Z",
    dateModification: "2023-11-05T16:10:00Z",
    conditions: [
      "Compte Orange Money actif",
      "Code PIN requis",
      "Vérification SMS"
    ],
    fournisseur: "Orange Money",
    contactFournisseur: "support@orange-money.com",
    integration: {
      apiDisponible: true,
      documentation: "https://api.orange-money.com",
      support24h: true
    }
  },
  {
    id: 4,
    code: "MTN_MONEY",
    nom: "MTN Mobile Money",
    type: "mobile",
    categorie: "mobile",
    statut: "actif",
    commission: 1.9,
    delaiReglement: 1,
    fraisFixe: 100,
    seuilMinimum: 100,
    seuilMaximum: 1000000,
    disponibilite: ["mobile", "guichet"],
    tauxSuccess: 98.9,
    volumeMensuel: 650000000,
    nombreTransactions: 152000,
    description: "Service de paiement mobile par MTN",
    dateCreation: "2023-02-15T11:30:00Z",
    dateModification: "2023-10-20T09:15:00Z",
    conditions: [
      "Compte MTN Mobile Money",
      "USSD *126#",
      "Vérification par code"
    ],
    fournisseur: "MTN Group",
    contactFournisseur: "mobilemoney@mtn.com",
    integration: {
      apiDisponible: true,
      documentation: "https://api.mtn.com",
      support24h: true
    }
  },
  {
    id: 5,
    code: "ESPECE",
    nom: "Espèces",
    type: "espece",
    categorie: "physique",
    statut: "actif",
    commission: 0,
    delaiReglement: 0,
    fraisFixe: 0,
    seuilMinimum: 1,
    seuilMaximum: 500000,
    disponibilite: ["guichet"],
    tauxSuccess: 100,
    volumeMensuel: 450000000,
    nombreTransactions: 125000,
    description: "Paiement en espèces aux guichets",
    dateCreation: "2023-01-01T00:00:00Z",
    dateModification: "2023-11-10T10:00:00Z",
    conditions: [
      "Montant exact recommandé",
      "Reçu obligatoire",
      "Heures d'ouverture des guichets"
    ],
    fournisseur: "Trésor Public",
    contactFournisseur: "N/A",
    integration: {
      apiDisponible: false,
      documentation: "N/A",
      support24h: false
    }
  },
  {
    id: 6,
    code: "VIREMENT",
    nom: "Virement Bancaire",
    type: "virement",
    categorie: "bancaire",
    statut: "actif",
    commission: 0.5,
    delaiReglement: 3,
    fraisFixe: 0,
    seuilMinimum: 10000,
    seuilMaximum: 10000000,
    disponibilite: ["en_ligne", "guichet"],
    tauxSuccess: 99.5,
    volumeMensuel: 850000000,
    nombreTransactions: 8500,
    description: "Virement bancaire national et international",
    dateCreation: "2023-01-25T14:20:00Z",
    dateModification: "2023-10-25T15:45:00Z",
    conditions: [
      "RIB requis",
      "Délai de traitement 24-72h",
      "Frais selon la banque"
    ],
    fournisseur: "Banques partenaires",
    contactFournisseur: "virements@banque.gov",
    integration: {
      apiDisponible: true,
      documentation: "https://api.virements.gov",
      support24h: false
    }
  },
  {
    id: 7,
    code: "PAYPAL",
    nom: "PayPal",
    type: "en_ligne",
    categorie: "électronique",
    statut: "actif",
    commission: 3.5,
    delaiReglement: 1,
    fraisFixe: 0,
    seuilMinimum: 100,
    seuilMaximum: 500000,
    disponibilite: ["en_ligne"],
    tauxSuccess: 96.8,
    volumeMensuel: 280000000,
    nombreTransactions: 18500,
    description: "Plateforme de paiement en ligne sécurisée",
    dateCreation: "2023-03-05T13:15:00Z",
    dateModification: "2023-11-02T12:30:00Z",
    conditions: [
      "Compte PayPal vérifié",
      "Email valide requis",
      "Conversion devise possible"
    ],
    fournisseur: "PayPal Holdings",
    contactFournisseur: "merchant@paypal.com",
    integration: {
      apiDisponible: true,
      documentation: "https://developer.paypal.com",
      support24h: true
    }
  },
  {
    id: 8,
    code: "WAVE",
    nom: "Wave",
    type: "mobile",
    categorie: "mobile",
    statut: "actif",
    commission: 1.5,
    delaiReglement: 1,
    fraisFixe: 0,
    seuilMinimum: 100,
    seuilMaximum: 500000,
    disponibilite: ["mobile", "en_ligne"],
    tauxSuccess: 99.1,
    volumeMensuel: 420000000,
    nombreTransactions: 95000,
    description: "Application mobile de paiement et transfert",
    dateCreation: "2023-03-20T10:45:00Z",
    dateModification: "2023-10-30T14:20:00Z",
    conditions: [
      "Application mobile installée",
      "Numéro de téléphone valide",
      "Compte vérifié"
    ],
    fournisseur: "Wave Mobile Money",
    contactFournisseur: "support@wave.com",
    integration: {
      apiDisponible: true,
      documentation: "https://developer.wave.com",
      support24h: true
    }
  },
  {
    id: 9,
    code: "CHEQUE",
    nom: "Chèque",
    type: "cheque",
    categorie: "bancaire",
    statut: "limite",
    commission: 1.0,
    delaiReglement: 5,
    fraisFixe: 500,
    seuilMinimum: 5000,
    seuilMaximum: 2000000,
    disponibilite: ["guichet"],
    tauxSuccess: 95.2,
    volumeMensuel: 120000000,
    nombreTransactions: 4500,
    description: "Paiement par chèque bancaire",
    dateCreation: "2023-01-10T09:30:00Z",
    dateModification: "2023-09-15T11:00:00Z",
    conditions: [
      "Chèque tiré sur banque locale",
      "Provisions suffisantes",
      "Délai de compensation 5 jours"
    ],
    fournisseur: "Banques locales",
    contactFournisseur: "N/A",
    integration: {
      apiDisponible: false,
      documentation: "N/A",
      support24h: false
    }
  },
  {
    id: 10,
    code: "CRYPTOCARD",
    nom: "Carte Cryptomonnaie",
    type: "carte",
    categorie: "electronique",
    statut: "test",
    commission: 1.2,
    delaiReglement: 0,
    fraisFixe: 0,
    seuilMinimum: 5000,
    seuilMaximum: 1000000,
    disponibilite: ["en_ligne"],
    tauxSuccess: 94.5,
    volumeMensuel: 25000000,
    nombreTransactions: 850,
    description: "Carte prépayée alimentée en cryptomonnaies",
    dateCreation: "2023-08-01T15:00:00Z",
    dateModification: "2023-11-12T10:15:00Z",
    conditions: [
      "Conversion en devise locale automatique",
      "Alimentation en BTC/ETH",
      "Frais de conversion variables"
    ],
    fournisseur: "CryptoCard Solutions",
    contactFournisseur: "sales@cryptocard.com",
    integration: {
      apiDisponible: true,
      documentation: "https://api.cryptocard.com",
      support24h: false
    }
  },
  {
    id: 11,
    code: "QR_PAIEMENT",
    nom: "Paiement QR Code",
    type: "qr",
    categorie: "mobile",
    statut: "actif",
    commission: 0.8,
    delaiReglement: 0,
    fraisFixe: 0,
    seuilMinimum: 100,
    seuilMaximum: 500000,
    disponibilite: ["mobile", "en_ligne"],
    tauxSuccess: 99.7,
    volumeMensuel: 320000000,
    nombreTransactions: 125000,
    description: "Paiement par scan de QR code",
    dateCreation: "2023-05-15T11:45:00Z",
    dateModification: "2023-11-08T09:30:00Z",
    conditions: [
      "Application de scan compatible",
      "Connexion internet requise",
      "QR code généré dynamiquement"
    ],
    fournisseur: "QR Payment Systems",
    contactFournisseur: "info@qrpayments.com",
    integration: {
      apiDisponible: true,
      documentation: "https://developer.qrpayments.com",
      support24h: true
    }
  },
  {
    id: 12,
    code: "MANDAT",
    nom: "Mandat Postal",
    type: "mandat",
    categorie: "physique",
    statut: "inactif",
    commission: 2.0,
    delaiReglement: 7,
    fraisFixe: 1000,
    seuilMinimum: 1000,
    seuilMaximum: 500000,
    disponibilite: ["guichet"],
    tauxSuccess: 92.3,
    volumeMensuel: 45000000,
    nombreTransactions: 2800,
    description: "Paiement par mandat postal",
    dateCreation: "2023-01-05T08:00:00Z",
    dateModification: "2023-06-30T16:45:00Z",
    conditions: [
      "Formulaire à remplir",
      "Pièce d'identité requise",
      "Délai de traitement long"
    ],
    fournisseur: "Poste Nationale",
    contactFournisseur: "mandats@poste.gov",
    integration: {
      apiDisponible: false,
      documentation: "N/A",
      support24h: false
    }
  }
];

export default function MoyensPaiementPage() {
  const navigate = useNavigate();
  
  // États principaux
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [sortField, setSortField] = useState('volumeMensuel');
  const [sortDirection, setSortDirection] = useState('desc');
  const [selectedMethods, setSelectedMethods] = useState([]);
  
  // États pour les filtres
  const [selectedType, setSelectedType] = useState('all');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');
  
  // États pour les modals
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showStatsModal, setShowStatsModal] = useState(false);
  
  // État pour le moyen de paiement sélectionné
  const [selectedMethod, setSelectedMethod] = useState(null);
  
  // État pour le formulaire
  const [formData, setFormData] = useState({
    code: '',
    nom: '',
    type: 'carte',
    categorie: 'électronique',
    statut: 'actif',
    commission: 0,
    delaiReglement: 0,
    fraisFixe: 0,
    seuilMinimum: 0,
    seuilMaximum: 0,
    description: '',
    fournisseur: '',
    contactFournisseur: '',
    disponibilite: []
  });
  const defaultCurrency = sessionStorage.getItem("default_currency") || 'XOF';
  // États pour les notifications Toast
  const [toastNotifications, setToastNotifications] = useState([]);
  const [alertMessage, setAlertMessage] = useState({ show: false, message: '', type: 'info' });
  
  // États pour les statistiques globales
  const [globalStats, setGlobalStats] = useState({
    totalVolume: 0,
    totalTransactions: 0,
    tauxSuccessMoyen: 0,
    methodesActives: 0
  });

  // Types de moyens de paiement
  const methodTypes = [
    { value: "all", label: "Tous les types", icon: <CreditCard /> },
    { value: "carte", label: "Carte bancaire", icon: <CreditCardFill />, color: "primary" },
    { value: "mobile", label: "Mobile Money", icon: <Phone />, color: "success" },
    { value: "espece", label: "Espèces", icon: <CashStack />, color: "warning" },
    { value: "virement", label: "Virement", icon: <Bank />, color: "info" },
    { value: "en_ligne", label: "En ligne", icon: <Globe />, color: "secondary" },
    { value: "cheque", label: "Chèque", icon: <Bank />, color: "dark" },
    { value: "qr", label: "QR Code", icon: <QrCode />, color: "primary" },
    { value: "mandat", label: "Mandat", icon: <Building />, color: "warning" }
  ];

  // Catégories
  const categories = [
    { value: "all", label: "Toutes catégories" },
    { value: "électronique", label: "Électronique", color: "primary" },
    { value: "mobile", label: "Mobile", color: "success" },
    { value: "physique", label: "Physique", color: "warning" },
    { value: "bancaire", label: "Bancaire", color: "info" }
  ];

  // Statuts
  const statuses = [
    { value: "all", label: "Tous les statuts" },
    { value: "actif", label: "Actif", color: "success" },
    { value: "inactif", label: "Inactif", color: "danger" },
    { value: "limite", label: "Limité", color: "warning" },
    { value: "test", label: "En test", color: "info" },
    { value: "maintenance", label: "Maintenance", color: "secondary" }
  ];

  // Options de disponibilité
  const availabilityOptions = [
    { value: "en_ligne", label: "En ligne", icon: <Globe /> },
    { value: "mobile", label: "Mobile", icon: <Phone /> },
    { value: "guichet", label: "Guichet", icon: <Building /> }
  ];

  // Initialiser les données
  useEffect(() => {
    setTimeout(() => {
      setPaymentMethods(demoPaymentMethods);
      setLoading(false);
      
      // Calculer les statistiques globales
      const totalVolume = demoPaymentMethods.reduce((sum, method) => sum + method.volumeMensuel, 0);
      const totalTransactions = demoPaymentMethods.reduce((sum, method) => sum + method.nombreTransactions, 0);
      const tauxSuccessMoyen = demoPaymentMethods.reduce((sum, method) => sum + method.tauxSuccess, 0) / demoPaymentMethods.length;
      const methodesActives = demoPaymentMethods.filter(m => m.statut === 'actif').length;
      
      setGlobalStats({
        totalVolume,
        totalTransactions,
        tauxSuccessMoyen,
        methodesActives
      });
    }, 800);
  }, []);

  // Fonctions pour les notifications Toast
  const showToast = (message, type = 'info', duration = 5000) => {
    const id = Date.now();
    const toast = {
      id,
      message,
      type,
      show: true
    };
    
    setToastNotifications(prev => [toast, ...prev]);
    
    setTimeout(() => {
      hideToast(id);
    }, duration);
  };

  const hideToast = (id) => {
    setToastNotifications(prev => prev.filter(toast => toast.id !== id));
  };

  const showAlert = (message, type = 'warning', duration = 5000) => {
    setAlertMessage({ show: true, message, type });
    
    if (duration > 0) {
      setTimeout(() => {
        hideAlert();
      }, duration);
    }
  };

  const hideAlert = () => {
    setAlertMessage({ show: false, message: '', type: 'info' });
  };

  // Fonction d'export PDF
  // Fonction d'export PDF améliorée
// Fonction d'export PDF améliorée - version corrigée
const exportToPDF = (methodsToExport, exportType = 'selected') => {
  try {
    const doc = new jsPDF('p', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 15;
    const lineHeight = 6;
    const rowHeight = 8;
    let yPos = margin;
    let pageNumber = 1;
    let hasAddedStatsPage = false;
    
    // Fonction pour ajouter une nouvelle page
    const addNewPage = () => {
      doc.addPage();
      yPos = margin;
      pageNumber++;
    };
    
    // Fonction pour vérifier l'espace disponible
    const checkSpace = (neededHeight) => {
      if (yPos + neededHeight > pageHeight - margin) {
        addNewPage();
        return true;
      }
      return false;
    };
    
    // En-tête du document
    doc.setFillColor(0, 102, 204);
    doc.rect(0, 0, pageWidth, 45, 'F');
    
    // Titre principal
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(22);
    doc.setFont('helvetica', 'bold');
    doc.text('RAPPORT DES MOYENS DE PAIEMENT', pageWidth / 2, 20, { align: 'center' });
    
    // Sous-titre
    doc.setFontSize(11);
    doc.text(`Généré le ${new Date().toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })}`, pageWidth / 2, 28, { align: 'center' });
    
    // Informations sur l'export
    doc.setFontSize(9);
    doc.text(`Type d'export: ${exportType === 'selected' ? 'Moyens sélectionnés' : 'Tous les moyens filtrés'}`, pageWidth / 2, 35, { align: 'center' });
    doc.text(`Nombre de moyens: ${methodsToExport.length}`, pageWidth / 2, 40, { align: 'center' });
    
    yPos = 50;
    
    // Statistiques de synthèse
    checkSpace(30);
    
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('SYNTHÈSE', margin, yPos);
    
    yPos += 8;
    
    // Calcul des statistiques
    const totalVolume = methodsToExport.reduce((sum, m) => sum + m.volumeMensuel, 0);
    const totalTransactions = methodsToExport.reduce((sum, m) => sum + m.nombreTransactions, 0);
    const tauxSuccessMoyen = methodsToExport.reduce((sum, m) => sum + m.tauxSuccess, 0) / methodsToExport.length;
    const methodesActives = methodsToExport.filter(m => m.statut === 'actif').length;
    const commissionMoyenne = methodsToExport.reduce((sum, m) => sum + m.commission, 0) / methodsToExport.length;
    
    // Statistiques sur 2 colonnes
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    const statsLeft = [
      [`Volume total:`, formatCurrency(totalVolume)],
      [`Transactions totales:`, totalTransactions.toLocaleString()],
      [`Taux succès moyen:`, `${tauxSuccessMoyen.toFixed(1)}%`]
    ];
    
    const statsRight = [
      [`Moyens actifs:`, `${methodesActives}/${methodsToExport.length}`],
      [`Commission moyenne:`, `${commissionMoyenne.toFixed(2)}%`],
      [`Date génération:`, new Date().toLocaleDateString('fr-FR')]
    ];
    
    const startY = yPos;
    const colWidth = (pageWidth - (margin * 3)) / 2;
    
    // Colonne gauche
    let currentY = startY;
    statsLeft.forEach(([label, value]) => {
      doc.text(label, margin, currentY);
      doc.text(value, margin + 50, currentY);
      currentY += lineHeight;
    });
    
    // Colonne droite
    currentY = startY;
    statsRight.forEach(([label, value]) => {
      doc.text(label, margin + colWidth + 20, currentY);
      doc.text(value, margin + colWidth + 70, currentY);
      currentY += lineHeight;
    });
    
    yPos = Math.max(startY + (statsLeft.length * lineHeight) + 4, startY + (statsRight.length * lineHeight) + 4);
    
    yPos += 12;
    
    // Tableau des moyens de paiement
    checkSpace(25);
    
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('LISTE DES MOYENS DE PAIEMENT', margin, yPos);
    yPos += 8;
    
    // En-têtes du tableau
    doc.setFillColor(240, 240, 240);
    const headerHeight = 8;
    doc.rect(margin, yPos, pageWidth - (margin * 2), headerHeight, 'F');
    
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    
    const colWidths = [30, 45, 25, 20, 30, 20];
    const headers = ['CODE', 'NOM', 'TYPE', 'COMM.', 'VOLUME', 'STATUT'];
    
    let xPos = margin;
    headers.forEach((header, index) => {
      doc.text(header, xPos + 2, yPos + 6);
      xPos += colWidths[index];
    });
    
    yPos += headerHeight + 2;
    
    // Données essentielles
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    
    methodsToExport.forEach((method, index) => {
      if (checkSpace(rowHeight + 2)) {
        doc.setFillColor(240, 240, 240);
        doc.rect(margin, yPos, pageWidth - (margin * 2), headerHeight, 'F');
        
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        
        xPos = margin;
        headers.forEach((header, idx) => {
          doc.text(header, xPos + 2, yPos + 6);
          xPos += colWidths[idx];
        });
        
        yPos += headerHeight + 2;
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(9);
      }
      
      const rectHeight = rowHeight;
      if (index % 2 === 0) {
        doc.setFillColor(245, 245, 245);
        doc.rect(margin, yPos - 1, pageWidth - (margin * 2), rectHeight, 'F');
      }
      
      const statusColor = method.statut === 'actif' ? [34, 139, 34] : 
                         method.statut === 'inactif' ? [220, 53, 69] :
                         method.statut === 'limite' ? [255, 193, 7] : [108, 117, 125];
      
      xPos = margin;
      
      doc.setTextColor(0, 0, 0);
      doc.text(method.code, xPos + 2, yPos + 4);
      xPos += colWidths[0];
      
      const shortName = method.nom.length > 20 ? method.nom.substring(0, 17) + '...' : method.nom;
      doc.text(shortName, xPos + 2, yPos + 4);
      xPos += colWidths[1];
      
      const typeLabel = methodTypes.find(t => t.value === method.type)?.label || method.type;
      const displayType = typeLabel.length > 10 ? typeLabel.substring(0, 7) + '...' : typeLabel;
      doc.text(displayType, xPos + 2, yPos + 4);
      xPos += colWidths[2];
      
      doc.setTextColor(220, 120, 0);
      doc.text(`${method.commission}%`, xPos + 2, yPos + 4);
      xPos += colWidths[3];
      
      doc.setTextColor(0, 0, 0);
      const volumeText = formatVolumeForPDF(method.volumeMensuel);
      doc.text(volumeText, xPos + 2, yPos + 4);
      xPos += colWidths[4];
      
      doc.setTextColor(statusColor[0], statusColor[1], statusColor[2]);
      const statusLabel = statuses.find(s => s.value === method.statut)?.label || method.statut;
      const shortStatus = statusLabel.length > 6 ? statusLabel.substring(0, 3) + '...' : statusLabel;
      doc.text(shortStatus.toUpperCase(), xPos + 2, yPos + 4);
      
      doc.setDrawColor(230, 230, 230);
      doc.line(margin, yPos + rectHeight, pageWidth - margin, yPos + rectHeight);
      
      yPos += rowHeight;
    });
    
    yPos += 15;
    
    // Analyse par type - CORRECTION ICI
    // Calculer la hauteur nécessaire
    const typeStats = {};
    methodsToExport.forEach(method => {
      typeStats[method.type] = (typeStats[method.type] || 0) + 1;
    });
    
    const types = Object.entries(typeStats).sort((a, b) => b[1] - a[1]);
    
    // Vérifier l'espace pour la section entière
    const sectionHeaderHeight = 15;
    const perItemHeight = 12; // Plus d'espace pour chaque élément
    const totalSectionHeight = sectionHeaderHeight + (types.length * perItemHeight);
    
    if (checkSpace(totalSectionHeight)) {
      hasAddedStatsPage = true;
    }
    
    // Titre de la section
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('RÉPARTITION PAR TYPE', margin, yPos);
    yPos += 10;
    
    // Configuration des barres de progression
    const barStartX = margin + 70; // Position X de départ des barres
    const barWidth = 60; // Largeur des barres réduite pour plus d'espace
    const barHeight = 5; // Hauteur des barres
    const barSpacing = 8; // Espacement vertical entre les barres
    const percentageX = barStartX + barWidth + 10; // Position X des pourcentages (plus d'espace)
    
    doc.setFontSize(9);
    
    types.forEach(([type, count], index) => {
      // Vérifier l'espace pour chaque élément
      if (checkSpace(perItemHeight)) {
        yPos += 5;
      }
      
      const percentage = ((count / methodsToExport.length) * 100).toFixed(1);
      const typeLabel = methodTypes.find(t => t.value === type)?.label || type;
      
      // Type label (tronqué si trop long)
      const maxTypeLength = 20;
      const shortTypeLabel = typeLabel.length > maxTypeLength 
        ? typeLabel.substring(0, maxTypeLength - 3) + '...' 
        : typeLabel;
      
      // Afficher le type et le compteur
      doc.text(`${shortTypeLabel}:`, margin, yPos);
      doc.text(`${count}`, margin + 55, yPos);
      
      // Barre de progression avec espacement amélioré
      const filledWidth = (percentage / 100) * barWidth;
      
      // Fond de la barre (gris clair)
      doc.setFillColor(240, 240, 240);
      doc.rect(barStartX, yPos - 3, barWidth, barHeight, 'F');
      
      // Partie remplie de la barre (couleur selon le type)
      const typeConfig = methodTypes.find(t => t.value === type);
      const color = typeConfig?.color || 'primary';
      const rgbColors = {
        'primary': [0, 102, 204],
        'success': [40, 167, 69],
        'warning': [255, 193, 7],
        'info': [23, 162, 184],
        'secondary': [108, 117, 125]
      };
      
      const rgb = rgbColors[color] || rgbColors.primary;
      doc.setFillColor(rgb[0], rgb[1], rgb[2]);
      doc.rect(barStartX, yPos - 3, filledWidth, barHeight, 'F');
      
      // Pourcentage avec espacement par rapport à la barre
      doc.setTextColor(0, 0, 0);
      doc.text(`${percentage}%`, percentageX, yPos);
      
      yPos += barSpacing;
    });
    
    yPos += 10;
    
    // Résumé final
    if (!hasAddedStatsPage && checkSpace(100)) {
      hasAddedStatsPage = true;
    }
    
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text('RÉSUMÉ ET RECOMMANDATIONS', margin, yPos);
    yPos += 10;
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    const recommendations = [
      `• ${methodsToExport.length} moyens de paiement analysés`,
      `• Volume total des transactions: ${formatCurrency(totalVolume)}`,
      `• ${methodesActives} moyen(s) actif(s) sur ${methodsToExport.length}`,
      `• Taux de succès moyen: ${tauxSuccessMoyen.toFixed(1)}%`,
      `• Commission moyenne: ${commissionMoyenne.toFixed(2)}%`,
      `• Date d'analyse: ${new Date().toLocaleDateString('fr-FR')}`,
      `• Heure de génération: ${new Date().toLocaleTimeString('fr-FR', { 
        hour: '2-digit', 
        minute: '2-digit' 
      })}`
    ];
    
    recommendations.forEach((rec, index) => {
      if (index === 0) {
        doc.setFont('helvetica', 'bold');
      } else {
        doc.setFont('helvetica', 'normal');
      }
      doc.text(rec, margin, yPos);
      yPos += 6;
    });
    
    yPos += 10;
    
    // Notes finales
    doc.setFontSize(9);
    doc.setTextColor(100, 100, 100);
    
    const notes = [
      "Notes:",
      "- Ce rapport présente uniquement les informations essentielles",
      "- Les montants sont exprimés en XOF",
      "- Les pourcentages sont arrondis à une décimale",
      "- Document généré automatiquement par le système"
    ];
    
    notes.forEach((note, index) => {
      if (index === 0) {
        doc.setFont('helvetica', 'bold');
      } else {
        doc.setFont('helvetica', 'normal');
      }
      doc.text(note, margin, yPos);
      yPos += 5;
    });
    
    // Pied de page sur toutes les pages
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      
      doc.setFontSize(8);
      doc.setTextColor(128, 128, 128);
      doc.text(
        `Page ${i} sur ${totalPages}`,
        pageWidth / 2,
        pageHeight - 10,
        { align: 'center' }
      );
      
      doc.setDrawColor(200, 200, 200);
      doc.line(margin, pageHeight - 15, pageWidth - margin, pageHeight - 15);
      
      doc.text(
        `© ${new Date().getFullYear()} Fiscalité Admin • Rapport confidentiel`,
        pageWidth - margin,
        pageHeight - 10,
        { align: 'right' }
      );
    }
    
    // Sauvegarder le PDF
    const fileName = `moyens_paiement_${new Date().toISOString().split('T')[0]}_${Date.now()}.pdf`;
    doc.save(fileName);
    
    showToast(`PDF exporté avec succès (${methodsToExport.length} moyens)`, 'success');
    return true;
    
  } catch (error) {
   
    showToast('Erreur lors de la génération du PDF: ' + error.message, 'error');
    return false;
  }
};
// Fonction helper spécifique pour le formatage PDF (utilise un format différent)
const formatVolumeForPDF = (amount) => {
  if (!amount && amount !== 0) return "0";
  if (amount === 0) return "0";
  
  if (amount >= 1000000000) {
    return (amount / 1000000000).toFixed(1).replace('.', ',') + ' Md';
  } else if (amount >= 1000000) {
    return (amount / 1000000).toFixed(1).replace('.', ',') + ' M';
  } else if (amount >= 1000) {
    return (amount / 1000).toFixed(1).replace('.', ',') + ' K';
  }
  
  return Math.round(amount).toLocaleString('fr-FR');
};

// Améliorer aussi la fonction formatShortCurrency pour le PDF


  // Fonction d'export Excel
  const exportToExcel = (methodsToExport, exportType = 'selected') => {
    try {
      // Préparer les données
      const data = methodsToExport.map(method => ({
        'Code': method.code,
        'Nom': method.nom,
        'Type': methodTypes.find(t => t.value === method.type)?.label || method.type,
        'Catégorie': method.categorie,
        'Statut': statuses.find(s => s.value === method.statut)?.label || method.statut,
        'Commission (%)': method.commission,
        'Délai règlement (jours)': method.delaiReglement,
        'Frais fixe (XOF)': method.fraisFixe,
        'Seuil minimum (XOF)': method.seuilMinimum,
        'Seuil maximum (XOF)': method.seuilMaximum,
        'Taux succès (%)': method.tauxSuccess,
        'Volume mensuel (XOF)': method.volumeMensuel,
        'Transactions mensuelles': method.nombreTransactions,
        'Fournisseur': method.fournisseur,
        'Contact fournisseur': method.contactFournisseur,
        'Date création': formatDate(method.dateCreation),
        'Date modification': formatDate(method.dateModification)
      }));
      
      // Créer un nouveau classeur
      const wb = XLSX.utils.book_new();
      
      // Feuille principale
      const ws = XLSX.utils.json_to_sheet(data);
      
      // Largeur des colonnes
      const colWidths = [
        { wch: 25 }, // Code
        { wch: 25 }, // Nom
        { wch: 25 }, // Type
        { wch: 15 }, // Catégorie
        { wch: 12 }, // Statut
        { wch: 12 }, // Commission
        { wch: 15 }, // Délai
        { wch: 15 }, // Frais fixe
        { wch: 15 }, // Seuil min
        { wch: 15 }, // Seuil max
        { wch: 12 }, // Taux succès
        { wch: 15 }, // Volume
        { wch: 18 }, // Transactions
        { wch: 20 }, // Fournisseur
        { wch: 25 }, // Contact
        { wch: 20 }, // Date création
        { wch: 20 }  // Date modif
      ];
      ws['!cols'] = colWidths;
      
      // Ajouter la feuille au classeur
      XLSX.utils.book_append_sheet(wb, ws, 'Moyens Paiement');
      
      // Feuille de statistiques
      const totalVolume = methodsToExport.reduce((sum, m) => sum + m.volumeMensuel, 0);
      const totalTransactions = methodsToExport.reduce((sum, m) => sum + m.nombreTransactions, 0);
      const tauxSuccessMoyen = methodsToExport.reduce((sum, m) => sum + m.tauxSuccess, 0) / methodsToExport.length;
      const methodesActives = methodsToExport.filter(m => m.statut === 'actif').length;
      const commissionMoyenne = methodsToExport.reduce((sum, m) => sum + m.commission, 0) / methodsToExport.length;
      
      const statsData = [
        ['Statistiques des moyens de paiement exportés'],
        [''],
        ['Nombre total de moyens', methodsToExport.length],
        ['Volume total (XOF)', totalVolume],
        ['Transactions totales', totalTransactions],
        ['Taux de succès moyen (%)', tauxSuccessMoyen.toFixed(2)],
        ['Moyens actifs', methodesActives],
        ['Commission moyenne (%)', commissionMoyenne.toFixed(2)],
        [''],
        ['Date d\'export', new Date().toLocaleString('fr-FR')],
        ['Type d\'export', exportType === 'selected' ? 'Moyens sélectionnés' : 'Tous les moyens filtrés']
      ];
      
      const wsStats = XLSX.utils.aoa_to_sheet(statsData);
      XLSX.utils.book_append_sheet(wb, wsStats, 'Statistiques');
      
      // Générer le fichier Excel
      const fileName = `moyens_paiement_${new Date().toISOString().split('T')[0]}.xlsx`;
      XLSX.writeFile(wb, fileName);
      
      showToast('Export Excel généré avec succès', 'success');
      return true;
      
    } catch (error) {
    
      showToast('Erreur lors de la génération du fichier Excel: ' + error.message, 'error');
      return false;
    }
  };

  // Fonction d'export CSV
  const exportToCSV = (methodsToExport) => {
    try {
      // En-têtes CSV
      const headers = [
        'Code',
        'Nom',
        'Type',
        'Catégorie',
        'Statut',
        'Commission (%)',
        'Délai règlement (jours)',
        'Frais fixe (XOF)',
        'Seuil minimum (XOF)',
        'Seuil maximum (XOF)',
        'Taux succès (%)',
        'Volume mensuel (XOF)',
        'Transactions mensuelles',
        'Fournisseur',
        'Contact fournisseur',
        'Date création',
        'Date modification'
      ];
      
      // Données
      const rows = methodsToExport.map(method => [
        method.code,
        `"${method.nom}"`,
        methodTypes.find(t => t.value === method.type)?.label || method.type,
        method.categorie,
        statuses.find(s => s.value === method.statut)?.label || method.statut,
        method.commission,
        method.delaiReglement,
        method.fraisFixe,
        method.seuilMinimum,
        method.seuilMaximum,
        method.tauxSuccess,
        method.volumeMensuel,
        method.nombreTransactions,
        method.fournisseur,
        method.contactFournisseur,
        formatDate(method.dateCreation),
        formatDate(method.dateModification)
      ]);
      
      // Convertir en CSV
      const csvContent = [
        headers.join(','),
        ...rows.map(row => row.join(','))
      ].join('\n');
      
      // Créer un blob et télécharger
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      
      link.setAttribute('href', url);
      link.setAttribute('download', `moyens_paiement_${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      showToast('Export CSV généré avec succès', 'success');
      return true;
      
    } catch (error) {
     
      showToast('Erreur lors de la génération du CSV: ' + error.message, 'error');
      return false;
    }
  };

  // Fonction pour exporter selon le format
 // Modifier la fonction confirmExportReports pour mieux gérer l'export
const confirmExportReports = (format = 'pdf') => {
  try {
    const methodsToExport = selectedMethods.length > 0 
      ? paymentMethods.filter(method => selectedMethods.includes(method.id))
      : filteredAndSortedItems;
    
    if (methodsToExport.length === 0) {
      showAlert("Aucun moyen de paiement à exporter", 'warning');
      return;
    }
    
    // Afficher une notification de démarrage
    const toastId = Date.now();
    showToast(`Export ${format.toUpperCase()} en cours...`, 'info');
    
    // Utiliser setTimeout pour éviter de bloquer l'interface
    setTimeout(() => {
      let success = false;
      
      try {
        switch(format.toLowerCase()) {
          case 'pdf':
            success = exportToPDF(methodsToExport, selectedMethods.length > 0 ? 'selected' : 'filtered');
            break;
          case 'excel':
          case 'xlsx':
            success = exportToExcel(methodsToExport, selectedMethods.length > 0 ? 'selected' : 'filtered');
            break;
          case 'csv':
            success = exportToCSV(methodsToExport);
            break;
          case 'json':
            // Export JSON simple
            const dataStr = JSON.stringify(methodsToExport, null, 2);
            const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
            const link = document.createElement('a');
            link.setAttribute('href', dataUri);
            link.setAttribute('download', `moyens_paiement_${new Date().toISOString().split('T')[0]}.json`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            success = true;
            showToast('Export JSON généré avec succès', 'success');
            break;
          default:
            showAlert('Format d\'export non supporté', 'error');
            return;
        }
        
        if (success) {
          // Notification de succès déjà gérée dans les fonctions d'export
        }
      } catch (error) {
       
        showToast('Erreur lors de l\'export: ' + error.message, 'error');
      }
    }, 100);
    
    setShowExportModal(false);
    
  } catch (error) {
   
    showToast('Erreur: ' + error.message, 'error');
  }
};

  // Filtrer et trier les moyens de paiement
  const filteredAndSortedItems = useMemo(() => {
    let filtered = paymentMethods.filter(method => {
      const searchTerm = filterText.toLowerCase();
      
      // Filtre par recherche
      const matchesSearch = 
        method.code.toLowerCase().includes(searchTerm) ||
        method.nom.toLowerCase().includes(searchTerm) ||
        method.description.toLowerCase().includes(searchTerm) ||
        method.fournisseur.toLowerCase().includes(searchTerm);
      
      // Filtre par type
      if (selectedType !== 'all' && method.type !== selectedType) {
        return false;
      }
      
      // Filtre par catégorie
      if (selectedCategory !== 'all' && method.categorie !== selectedCategory) {
        return false;
      }
      
      // Filtre par statut
      if (selectedStatus !== 'all' && method.statut !== selectedStatus) {
        return false;
      }
      
      return matchesSearch;
    });

    // Tri
    filtered.sort((a, b) => {
      let aValue = a[sortField] || '';
      let bValue = b[sortField] || '';
      
      if (['volumeMensuel', 'nombreTransactions', 'tauxSuccess', 'commission', 'delaiReglement', 'fraisFixe', 'seuilMinimum', 'seuilMaximum'].includes(sortField)) {
        aValue = parseFloat(aValue) || 0;
        bValue = parseFloat(bValue) || 0;
      }
      
      if (sortField === 'dateCreation' || sortField === 'dateModification') {
        aValue = new Date(aValue).getTime();
        bValue = new Date(bValue).getTime();
      }
      
      if (sortDirection === 'asc') {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });

    return filtered;
  }, [paymentMethods, filterText, selectedType, selectedCategory, selectedStatus, sortField, sortDirection]);

  // Statistiques des moyens filtrés
  const filteredStats = useMemo(() => {
    const total = filteredAndSortedItems.length;
    const volumeTotal = filteredAndSortedItems.reduce((sum, m) => sum + m.volumeMensuel, 0);
    const transactionsTotal = filteredAndSortedItems.reduce((sum, m) => sum + m.nombreTransactions, 0);
    const tauxSuccessMoyen = total > 0 ? filteredAndSortedItems.reduce((sum, m) => sum + m.tauxSuccess, 0) / total : 0;
    const actifs = filteredAndSortedItems.filter(m => m.statut === 'actif').length;
    
    return { total, volumeTotal, transactionsTotal, tauxSuccessMoyen, actifs };
  }, [filteredAndSortedItems]);

  // Pagination
  const totalPages = Math.ceil(filteredAndSortedItems.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredAndSortedItems.slice(startIndex, startIndex + itemsPerPage);

  // Fonctions de tri
  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  // Gestion des sélections
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedMethods(currentItems.map(method => method.id));
    } else {
      setSelectedMethods([]);
    }
  };

  const handleSelectMethod = (methodId) => {
    setSelectedMethods(prev => 
      prev.includes(methodId) 
        ? prev.filter(id => id !== methodId)
        : [...prev, methodId]
    );
  };

  const isAllSelected = currentItems.length > 0 && selectedMethods.length === currentItems.length;
  const isSomeSelected = selectedMethods.length > 0 && selectedMethods.length < currentItems.length;

  // Formatage des montants
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return "N/A";
    if (amount === 0) return `0 ${defaultCurrency}`;
    
    if (amount >= 1000000000) {
      return `${(amount / 1000000000).toFixed(1)} Md ${defaultCurrency}`;
    } else if (amount >= 1000000) {
      return `${(amount / 1000000).toFixed(1)} M ${defaultCurrency}`;
    } else if (amount >= 1000) {
      return `${(amount / 1000).toFixed(1)} K ${defaultCurrency}`;
    }
    
    return `${amount.toLocaleString('fr-FR')} ${defaultCurrency}`;
  };

  const formatShortCurrency = (amount) => {
    if (!amount) return "0";
    if (amount >= 1000000000) {
      return (amount / 1000000000).toFixed(1) + ' Md';
    } else if (amount >= 1000000) {
      return (amount / 1000000).toFixed(1) + ' M';
    }
    return amount.toString();
  };

  // Formatage des dates
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Obtenir la couleur du type
  const getTypeColor = (type) => {
    const typeConfig = methodTypes.find(t => t.value === type);
    return typeConfig?.color || 'secondary';
  };

  // Obtenir l'icône du type
  const getTypeIcon = (type) => {
    const typeConfig = methodTypes.find(t => t.value === type);
    return typeConfig?.icon || <CreditCard />;
  };

  // Obtenir le badge de statut
  const getStatusBadge = (statut) => {
    const statusConfig = statuses.find(s => s.value === statut);
    const color = statusConfig?.color || 'secondary';
    
    const labels = {
      actif: "Actif",
      inactif: "Inactif",
      limite: "Limité",
      test: "En test",
      maintenance: "Maintenance"
    };
    
    return <Badge bg={color}>{labels[statut] || statut}</Badge>;
  };

  // Obtenir les badges de disponibilité
  const getAvailabilityBadges = (disponibilite) => {
    return disponibilite.map(disp => {
      const option = availabilityOptions.find(o => o.value === disp);
      return (
        <Badge key={disp} bg="light" text="dark" className="me-1">
          {option?.icon} {option?.label}
        </Badge>
      );
    });
  };

  // Voir les détails
  const viewDetails = (method) => {
    setSelectedMethod(method);
    setShowDetailsModal(true);
  };

  // Éditer un moyen de paiement
  const editMethod = (method) => {
    setSelectedMethod(method);
    setFormData({
      code: method.code,
      nom: method.nom,
      type: method.type,
      categorie: method.categorie,
      statut: method.statut,
      commission: method.commission,
      delaiReglement: method.delaiReglement,
      fraisFixe: method.fraisFixe,
      seuilMinimum: method.seuilMinimum,
      seuilMaximum: method.seuilMaximum,
      description: method.description,
      fournisseur: method.fournisseur,
      contactFournisseur: method.contactFournisseur,
      disponibilite: method.disponibilite || []
    });
    setShowEditModal(true);
  };

  // Créer un nouveau moyen de paiement
  const createNewMethod = () => {
    setFormData({
      code: '',
      nom: '',
      type: 'carte',
      categorie: 'électronique',
      statut: 'actif',
      commission: 0,
      delaiReglement: 0,
      fraisFixe: 0,
      seuilMinimum: 0,
      seuilMaximum: 0,
      description: '',
      fournisseur: '',
      contactFournisseur: '',
      disponibilite: []
    });
    setShowCreateModal(true);
  };

  // Gérer les changements du formulaire
  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      if (name === 'disponibilite') {
        const updatedDisponibilite = checked
          ? [...formData.disponibilite, value]
          : formData.disponibilite.filter(item => item !== value);
        setFormData(prev => ({ ...prev, disponibilite: updatedDisponibilite }));
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  // Valider la création
  const validateCreateMethod = () => {
    if (!formData.code || !formData.nom) {
      showAlert("Le code et le nom sont obligatoires", 'warning');
      return false;
    }
    
    if (paymentMethods.some(m => m.code === formData.code)) {
      showAlert("Ce code est déjà utilisé", 'warning');
      return false;
    }
    
    return true;
  };

  // Créer le moyen de paiement
  const handleCreateMethod = () => {
    if (!validateCreateMethod()) return;
    
    const newMethod = {
      id: paymentMethods.length + 1,
      ...formData,
      tauxSuccess: 95.0,
      volumeMensuel: 0,
      nombreTransactions: 0,
      dateCreation: new Date().toISOString(),
      dateModification: new Date().toISOString(),
      conditions: [],
      integration: {
        apiDisponible: false,
        documentation: '',
        support24h: false
      }
    };
    
    setPaymentMethods(prev => [newMethod, ...prev]);
    setShowCreateModal(false);
    showToast('Moyen de paiement créé avec succès', 'success');
    
    // Mettre à jour les stats
    setGlobalStats(prev => ({
      ...prev,
      totalVolume: prev.totalVolume + newMethod.volumeMensuel,
      totalTransactions: prev.totalTransactions + newMethod.nombreTransactions,
      methodesActives: newMethod.statut === 'actif' ? prev.methodesActives + 1 : prev.methodesActives
    }));
  };

  // Mettre à jour le moyen de paiement
  const handleUpdateMethod = () => {
    if (!selectedMethod) return;
    
    const updatedMethod = {
      ...selectedMethod,
      ...formData,
      dateModification: new Date().toISOString()
    };
    
    setPaymentMethods(prev => prev.map(m => 
      m.id === selectedMethod.id ? updatedMethod : m
    ));
    
    setShowEditModal(false);
    setSelectedMethod(null);
    showToast('Moyen de paiement mis à jour avec succès', 'success');
  };

  // Supprimer un moyen de paiement
  const deleteMethod = (method) => {
    setSelectedMethod(method);
    setShowDeleteModal(true);
  };

  const confirmDeleteMethod = () => {
    if (!selectedMethod) return;

    setPaymentMethods(prev => prev.filter(m => m.id !== selectedMethod.id));
    setShowDeleteModal(false);
    setSelectedMethods(prev => prev.filter(id => id !== selectedMethod.id));
    showToast('Moyen de paiement supprimé avec succès', 'success');
    
    // Mettre à jour les stats
    setGlobalStats(prev => ({
      ...prev,
      totalVolume: prev.totalVolume - selectedMethod.volumeMensuel,
      totalTransactions: prev.totalTransactions - selectedMethod.nombreTransactions,
      methodesActives: selectedMethod.statut === 'actif' ? prev.methodesActives - 1 : prev.methodesActives
    }));
  };

  // Suppression multiple
  const handleBulkDelete = () => {
    if (selectedMethods.length === 0) {
      showAlert("Veuillez sélectionner au moins un moyen de paiement", 'warning');
      return;
    }
    setShowBulkDeleteModal(true);
  };

  const handleConfirmBulkDelete = () => {
    const methodsToDelete = paymentMethods.filter(m => selectedMethods.includes(m.id));
    
    setPaymentMethods(prev => prev.filter(method => !selectedMethods.includes(method.id)));
    setSelectedMethods([]);
    setShowBulkDeleteModal(false);
    
    // Mettre à jour les stats
    const totalVolumeDelete = methodsToDelete.reduce((sum, m) => sum + m.volumeMensuel, 0);
    const totalTransactionsDelete = methodsToDelete.reduce((sum, m) => sum + m.nombreTransactions, 0);
    const methodesActivesDelete = methodsToDelete.filter(m => m.statut === 'actif').length;
    
    setGlobalStats(prev => ({
      ...prev,
      totalVolume: prev.totalVolume - totalVolumeDelete,
      totalTransactions: prev.totalTransactions - totalTransactionsDelete,
      methodesActives: prev.methodesActives - methodesActivesDelete
    }));
    
    showToast(`${selectedMethods.length} moyen(s) de paiement supprimé(s) avec succès`, 'success');
  };

  // Exporter des moyens de paiement
  const handleExportMethods = () => {
    setShowExportModal(true);
  };

  // Afficher les statistiques
  const showStatistics = () => {
    setShowStatsModal(true);
  };

  // Composant pour l'en-tête triable
  const SortableHeader = ({ field, children }) => (
    <th 
      style={{ cursor: 'pointer', userSelect: 'none' }}
      onClick={() => handleSort(field)}
      className="position-relative"
    >
      {children}
      {sortField === field && (
        <span className="ms-1">
          {sortDirection === 'asc' ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
        </span>
      )}
    </th>
  );

  // Composant pour la jauge de performance
  const PerformanceGauge = ({ value, max = 100 }) => {
    const percentage = Math.min((value / max) * 100, 100);
    let color = "success";
    
    if (percentage < 90) color = "warning";
    if (percentage < 80) color = "danger";
    
    return (
      <div className="d-flex align-items-center">
        <div style={{ flex: 1, marginRight: '10px' }}>
          <ProgressBar 
            now={percentage} 
            variant={color}
            style={{ height: '6px' }}
          />
        </div>
        <small className={`text-${color} fw-bold`}>
          {value.toFixed(1)}%
        </small>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Header />
      
      <div className="main main-app p-3 p-lg-4">
        {/* Container pour les notifications Toast */}
        <ToastContainer 
          position="top-end"
          className="p-3"
          style={{ zIndex: 9999 }}
        >
          {toastNotifications.map((toast) => (
            <Toast
              key={toast.id}
              show={toast.show}
              onClose={() => hideToast(toast.id)}
              delay={8000}
              autohide
              className={`bg-${toast.type === 'success' ? 'success' : 
                         toast.type === 'error' ? 'danger' :
                         toast.type === 'warning' ? 'warning' : 'info'} text-white`}
            >
              <Toast.Header className={`bg-${toast.type === 'success' ? 'success' : 
                         toast.type === 'error' ? 'danger' :
                         toast.type === 'warning' ? 'warning' : 'info'} text-white`}>
                {toast.type === 'success' ? <CheckCircle className="me-2" /> :
                 toast.type === 'error' ? <XCircle className="me-2" /> :
                 toast.type === 'warning' ? <ExclamationCircle className="me-2" /> :
                 <CheckCircle className="me-2" />}
                <strong className="me-auto">
                  {toast.type === 'success' ? 'Succès' : 
                   toast.type === 'error' ? 'Erreur' :
                   toast.type === 'warning' ? 'Attention' : 'Information'}
                </strong>
                <small>{new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}</small>
              </Toast.Header>
              <Toast.Body className="text-white">
                {toast.message}
              </Toast.Body>
            </Toast>
          ))}
        </ToastContainer>

        {/* Alerte Bootstrap */}
        {alertMessage.show && (
          <div className="container-fluid mb-3">
            <Alert 
              variant={alertMessage.type} 
              dismissible 
              onClose={hideAlert}
              className="shadow-sm border-0"
            >
              <div className="d-flex align-items-center">
                {alertMessage.type === 'success' ? <CheckCircle className="me-2 fs-5" /> :
                 alertMessage.type === 'danger' ? <XCircle className="me-2 fs-5" /> :
                 alertMessage.type === 'warning' ? <ExclamationCircle className="me-2 fs-5" /> :
                 <CheckCircle className="me-2 fs-5" />}
                <span className="fw-medium">{alertMessage.message}</span>
              </div>
            </Alert>
          </div>
        )}

        <div className="container-fluid">
          <Row className="mb-4">
            <Col md={12}>
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <ol className="breadcrumb fs-sm mb-1">
                    <li className="breadcrumb-item"><Link to="/admin/dashboard">Tableau de bord</Link></li>
                    <li className="breadcrumb-item"><Link to="/admin/configuration">Configuration</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Moyens de paiement</li>
                  </ol>
                  <h4 className="main-title mb-0">
                    <CreditCard className="me-2" />
                    Gestion des Moyens de Paiement
                  </h4>
                  <p className="text-muted mb-0">Configuration et suivi des méthodes de paiement acceptées</p>
                </div>

                <div className="d-flex gap-2">
                  {selectedMethods.length > 0 && (
                    <>
                      <Button 
                        variant="outline-primary"
                        onClick={handleExportMethods}
                        className="d-flex align-items-center"
                      >
                        <Download className="me-2" size={16} />
                        Exporter ({selectedMethods.length})
                      </Button>
                      <Button 
                        variant="outline-danger" 
                        size="sm"
                        onClick={handleBulkDelete}
                      >
                        <Trash className="me-2" size={16} />
                        Supprimer ({selectedMethods.length})
                      </Button>
                    </>
                  )}
                  
                  <Button 
                    variant="primary"
                    onClick={showStatistics}
                    className="d-flex align-items-center"
                  >
                    <Activity className="me-2" size={16} />
                    Statistiques
                  </Button>
                  
                  <Button 
                    variant="success"
                    onClick={createNewMethod}
                    className="d-flex align-items-center"
                  >
                    <PlusCircle className="me-2" size={16} />
                    Nouveau Moyen
                  </Button>
                  
                  <Button 
                    variant="outline-secondary" 
                    onClick={() => navigate(-1)}
                    className="d-flex align-items-center"
                  >
                    <ArrowLeft className="me-2" size={16} />
                    Retour
                  </Button>
                </div>
              </div>
            </Col>
          </Row>

          {/* Statistiques globales */}
          <Row className="g-3 mb-4">
            <Col md={3}>
              <Card className="border-0 shadow-sm overflow-hidden stats-card">
                <div className="card-gradient bg-primary"></div>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="text-uppercase text-muted mb-2">Volume Total</h6>
                      <h2 className="mb-0">{formatShortCurrency(globalStats.totalVolume)}</h2>
                      <div className="mt-2">
                        <Badge bg="primary-subtle" text="primary" className="fw-medium">
                          <Cash className="me-1" size={12} />
                          {defaultCurrency}
                        </Badge>
                      </div>
                    </div>
                    <div className="icon-container bg-primary-subtle">
                      <Cash className="text-primary" size={28} />
                    </div>
                  </div>
                  <div className="progress-wrapper mt-3">
                    <div className="d-flex justify-content-between mb-1">
                      <small className="text-muted">Moyens actifs</small>
                      <small className="fw-medium">{globalStats.methodesActives}/{paymentMethods.length}</small>
                    </div>
                    <ProgressBar 
                      now={paymentMethods.length > 0 ? (globalStats.methodesActives / paymentMethods.length) * 100 : 0} 
                      variant="primary"
                      className="stats-progress"
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            
            <Col md={3}>
              <Card className="border-0 shadow-sm overflow-hidden stats-card">
                <div className="card-gradient bg-success"></div>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="text-uppercase text-muted mb-2">Transactions</h6>
                      <h2 className="mb-0">{formatShortCurrency(globalStats.totalTransactions)}</h2>
                      <div className="mt-2">
                        <Badge bg="success-subtle" text="success" className="fw-medium">
                          <Activity className="me-1" size={12} />
                          Mensuel
                        </Badge>
                      </div>
                    </div>
                    <div className="icon-container bg-success-subtle">
                      <Activity className="text-success" size={28} />
                    </div>
                  </div>
                  <div className="progress-wrapper mt-3">
                    <div className="d-flex justify-content-between mb-1">
                      <small className="text-muted">Taux succès moyen</small>
                      <small className="fw-medium">{globalStats.tauxSuccessMoyen.toFixed(1)}%</small>
                    </div>
                    <ProgressBar 
                      now={globalStats.tauxSuccessMoyen} 
                      variant="success"
                      className="stats-progress"
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            
            <Col md={3}>
              <Card className="border-0 shadow-sm overflow-hidden stats-card">
                <div className="card-gradient bg-info"></div>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="text-uppercase text-muted mb-2">Total Moyens</h6>
                      <h2 className="mb-0">{paymentMethods.length}</h2>
                      <div className="mt-2">
                        <Badge bg="info-subtle" text="info" className="fw-medium">
                          <CreditCard className="me-1" size={12} />
                          Configurés
                        </Badge>
                      </div>
                    </div>
                    <div className="icon-container bg-info-subtle">
                      <CreditCard className="text-info" size={28} />
                    </div>
                  </div>
                  <div className="progress-wrapper mt-3">
                    <div className="d-flex justify-content-between mb-1">
                      <small className="text-muted">Filtrés</small>
                      <small className="fw-medium">{filteredStats.total}</small>
                    </div>
                    <ProgressBar 
                      now={paymentMethods.length > 0 ? (filteredStats.total / paymentMethods.length) * 100 : 0} 
                      variant="info"
                      className="stats-progress"
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
            
            <Col md={3}>
              <Card className="border-0 shadow-sm overflow-hidden stats-card">
                <div className="card-gradient bg-warning"></div>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="text-uppercase text-muted mb-2">Types Différents</h6>
                      <h2 className="mb-0">{[...new Set(paymentMethods.map(m => m.type))].length}</h2>
                      <div className="mt-2">
                        <Badge bg="warning-subtle" text="warning" className="fw-medium">
                          <Wallet className="me-1" size={12} />
                          Catégories
                        </Badge>
                      </div>
                    </div>
                    <div className="icon-container bg-warning-subtle">
                      <Wallet className="text-warning" size={28} />
                    </div>
                  </div>
                  <div className="progress-wrapper mt-3">
                    <div className="d-flex justify-content-between mb-1">
                      <small className="text-muted">Commission moyenne</small>
                      <small className="fw-medium">
                        {(paymentMethods.reduce((sum, m) => sum + m.commission, 0) / paymentMethods.length).toFixed(2)}%
                      </small>
                    </div>
                    <ProgressBar 
                      now={60} 
                      variant="warning"
                      className="stats-progress"
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Barre de recherche et filtres */}
          <Row className="mb-4">
            <Col md={12}>
              <Card className="border-0 shadow-sm">
                <Card.Body>
                  <Row className="g-3">
                    <Col md={3}>
                      <InputGroup>
                        <InputGroup.Text>
                          <Search />
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          placeholder="Rechercher un moyen de paiement..."
                          value={filterText}
                          onChange={(e) => setFilterText(e.target.value)}
                        />
                      </InputGroup>
                    </Col>
                    <Col md={2}>
                      <Form.Select value={selectedType} onChange={(e) => setSelectedType(e.target.value)}>
                        {methodTypes.map(type => (
                          <option key={type.value} value={type.value}>{type.label}</option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={2}>
                      <Form.Select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                        {categories.map(cat => (
                          <option key={cat.value} value={cat.value}>{cat.label}</option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={2}>
                      <Form.Select value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)}>
                        {statuses.map(status => (
                          <option key={status.value} value={status.value}>{status.label}</option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={3}>
                      <div className="d-flex gap-2">
                        <Button
                          variant="outline-secondary"
                          onClick={() => {
                            setFilterText("");
                            setSelectedType("all");
                            setSelectedCategory("all");
                            setSelectedStatus("all");
                          }}
                          className="w-100"
                        >
                          <X className="me-2" />
                          Réinitialiser
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Statistiques des moyens filtrés */}
          {filteredStats.total > 0 && (
            <Row className="mb-3">
              <Col md={12}>
                <Card className="border-0 shadow-sm bg-light">
                  <Card.Body className="py-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <small className="text-muted">
                          <strong>{filteredStats.total}</strong> moyen(s) trouvé(s) • 
                          Volume total: <strong>{formatCurrency(filteredStats.volumeTotal)}</strong> • 
                          Transactions: <strong>{filteredStats.transactionsTotal.toLocaleString()}</strong> • 
                          Taux succès: <strong>{filteredStats.tauxSuccessMoyen.toFixed(1)}%</strong>
                        </small>
                      </div>
                      <div>
                        <small className="text-muted">
                          {selectedMethods.length > 0 && (
                            <span className="text-primary">
                              {selectedMethods.length} sélectionné(s)
                            </span>
                          )}
                        </small>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {/* Tableau principal */}
          <Row>
            <Col md={12}>
              <Card className="shadow-sm border-0">
                <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center py-3">
                  <div className="d-flex align-items-center">
                    <CreditCard className="me-2" />
                    <span className="fw-semibold">Liste des Moyens de Paiement ({filteredStats.total})</span>
                  </div>
                  <div className="text-white-50 small">
                    {selectedMethods.length > 0 && (
                      <span>{selectedMethods.length} sélectionné(s)</span>
                    )}
                  </div>
                </Card.Header>
                
                <Card.Body className="p-0">
                  <div className="table-responsive">
                    <Table hover className="mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th style={{ width: '40px' }}>
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                style={{
                                  borderRadius: '50%',
                                  width: '18px',
                                  height: '18px',
                                  cursor: 'pointer'
                                }}
                                checked={isAllSelected}
                                ref={input => {
                                  if (input) {
                                    input.indeterminate = isSomeSelected;
                                  }
                                }}
                                onChange={handleSelectAll}
                              />
                            </div>
                          </th>
                          <th>Code</th>
                          <SortableHeader field="nom">
                            Nom
                          </SortableHeader>
                          <th>Type</th>
                          <SortableHeader field="commission">
                            Commission
                          </SortableHeader>
                          <SortableHeader field="volumeMensuel">
                            Volume
                          </SortableHeader>
                          <SortableHeader field="tauxSuccess">
                            Succès
                          </SortableHeader>
                          <th>Disponibilité</th>
                          <th>Statut</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="10" className="text-center py-5">
                              <div className="d-flex justify-content-center align-items-center">
                                <Spinner animation="border" variant="primary" className="me-3" />
                                <span className="text-muted">Chargement des moyens de paiement...</span>
                              </div>
                            </td>
                          </tr>
                        ) : currentItems.length > 0 ? (
                          currentItems.map((method) => (
                            <tr key={method.id}>
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  style={{
                                    borderRadius: '50%',
                                    width: '18px',
                                    height: '18px',
                                    cursor: 'pointer'
                                  }}
                                  checked={selectedMethods.includes(method.id)}
                                  onChange={() => handleSelectMethod(method.id)}
                                />
                              </td>
                              <td>
                                <Badge bg="dark" className="fw-medium">
                                  {method.code}
                                </Badge>
                              </td>
                              <td>
                                <div>
                                  <strong className="d-block">{method.nom}</strong>
                                  <small className="text-muted">
                                    <Building size={12} className="me-1" />
                                    {method.fournisseur}
                                  </small>
                                </div>
                              </td>
                              <td>
                                <div className={`text-${getTypeColor(method.type)}`} title={methodTypes.find(t => t.value === method.type)?.label}>
                                  {getTypeIcon(method.type)}
                                </div>
                              </td>
                              <td>
                                <div>
                                  <strong className="d-block text-warning">{method.commission}%</strong>
                                  <small className="text-muted">
                                    <Clock size={12} className="me-1" />
                                    {method.delaiReglement} jours
                                  </small>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <strong className="d-block">{formatShortCurrency(method.volumeMensuel)} {defaultCurrency}</strong>
                                  <small className="text-muted">
                                    {method.nombreTransactions.toLocaleString()} tx
                                  </small>
                                </div>
                              </td>
                              <td>
                                <PerformanceGauge value={method.tauxSuccess} />
                                <div className="text-muted small mt-1">
                                  Seuil: {formatCurrency(method.seuilMinimum)} - {formatCurrency(method.seuilMaximum)}
                                </div>
                              </td>
                              <td>
                                <div className="d-flex flex-wrap gap-1">
                                  {getAvailabilityBadges(method.disponibilite)}
                                </div>
                              </td>
                              <td>
                                {getStatusBadge(method.statut)}
                              </td>
                              <td>
                                <div className="d-flex gap-1">
                                  <Button
                                    size="sm"
                                    variant="outline-primary"
                                    title="Voir les détails"
                                    onClick={() => viewDetails(method)}
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: '32px', height: '32px' }}
                                  >
                                    <Eye size={14} />
                                  </Button>
                                  
                                  <Button
                                    size="sm"
                                    variant="outline-warning"
                                    title="Modifier"
                                    onClick={() => editMethod(method)}
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: '32px', height: '32px' }}
                                  >
                                    <Pencil size={14} />
                                  </Button>
                                  
                                  <Button
                                    size="sm"
                                    variant="outline-danger"
                                    title="Supprimer"
                                    onClick={() => deleteMethod(method)}
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: '32px', height: '32px' }}
                                  >
                                    <Trash size={14} />
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center py-5">
                              <CreditCard size={48} className="text-muted" />
                              <p className="mt-3 text-muted">AUCUN MOYEN DE PAIEMENT TROUVÉ.</p>
                              <p className="text-muted mb-3">
                                {filterText || selectedType !== 'all' || selectedCategory !== 'all' || selectedStatus !== 'all'
                                  ? "Aucun moyen de paiement ne correspond aux critères de recherche."
                                  : "Aucun moyen de paiement disponible pour le moment."}
                              </p>
                              {(filterText || selectedType !== 'all' || selectedCategory !== 'all' || selectedStatus !== 'all') && (
                                <Button 
                                  variant="outline-primary" 
                                  size="sm"
                                  onClick={() => {
                                    setFilterText("");
                                    setSelectedType("all");
                                    setSelectedCategory("all");
                                    setSelectedStatus("all");
                                  }}
                                >
                                  Réinitialiser les filtres
                                </Button>
                              )}
                              <Button 
                                variant="success" 
                                size="sm"
                                className="ms-2"
                                onClick={createNewMethod}
                              >
                                <PlusCircle className="me-2" />
                                Créer un moyen de paiement
                              </Button>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {/* Pagination */}
                  {totalPages > 1 && (
                    <div className="p-3 border-top d-flex justify-content-between align-items-center">
                      <div className="text-muted small">
                        Affichage de {startIndex + 1} à {Math.min(startIndex + itemsPerPage, filteredAndSortedItems.length)} sur {filteredAndSortedItems.length} moyens
                        {selectedMethods.length > 0 && (
                          <span className="ms-2 text-primary">• {selectedMethods.length} sélectionné(s)</span>
                        )}
                      </div>
                      <Pagination className="mb-0">
                        <Pagination.Prev 
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage(currentPage - 1)}
                        />
                        {[...Array(totalPages)].map((_, index) => (
                          <Pagination.Item
                            key={index + 1}
                            active={index + 1 === currentPage}
                            onClick={() => setCurrentPage(index + 1)}
                          >
                            {index + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next 
                          disabled={currentPage === totalPages}
                          onClick={() => setCurrentPage(currentPage + 1)}
                        />
                      </Pagination>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        {/* Modal de détails */}
        <Modal 
          show={showDetailsModal} 
          onHide={() => setShowDetailsModal(false)} 
          size="lg"
          centered
          className="modal-details"
        >
          {selectedMethod && (
            <>
              <Modal.Header closeButton className="border-0 pb-2">
                <Modal.Title className="w-100">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <div className="d-flex align-items-center">
                        <div className={`text-${getTypeColor(selectedMethod.type)} me-2`}>
                          {getTypeIcon(selectedMethod.type)}
                        </div>
                        <h4 className="mb-0">{selectedMethod.nom}</h4>
                        {getStatusBadge(selectedMethod.statut)}
                      </div>
                      <div className="text-muted small mt-1" style={{fontSize:'14px'}}>
                        Code: <Badge bg="dark">{selectedMethod.code}</Badge> • 
                        Créé le: {formatDateTime(selectedMethod.dateCreation)} • 
                        Modifié le: {formatDateTime(selectedMethod.dateModification)}
                      </div>
                    </div>
                  </div>
                </Modal.Title>
              </Modal.Header>
              
              <Modal.Body className="py-3">
                <Row>
                  <Col md={8}>
                    {/* Description */}
                    <Card className="border-0 shadow-sm mb-3">
                      <Card.Body>
                        <h5 className="mb-3 d-flex align-items-center">
                          <InfoCircle className="me-2 text-primary" />
                          Description
                        </h5>
                        <p className="mb-0">{selectedMethod.description}</p>
                      </Card.Body>
                    </Card>

                    {/* Conditions */}
                    {selectedMethod.conditions && selectedMethod.conditions.length > 0 && (
                      <Card className="border-0 shadow-sm mb-3">
                        <Card.Body>
                          <h5 className="mb-3 d-flex align-items-center">
                            <ShieldCheck className="me-2 text-primary" />
                            Conditions d'utilisation
                          </h5>
                          <ListGroup variant="flush">
                            {selectedMethod.conditions.map((condition, index) => (
                              <ListGroup.Item key={index} className="border-0 px-0 py-2">
                                <div className="d-flex">
                                  <CheckCircle className="text-success me-2 mt-1" size={16} />
                                  <span>{condition}</span>
                                </div>
                              </ListGroup.Item>
                            ))}
                          </ListGroup>
                        </Card.Body>
                      </Card>
                    )}

                     {/* Fournisseur */}
                    <Card className="border-0 shadow-sm">
                      <Card.Body>
                        <h5 className="mb-3 d-flex align-items-center">
                          <Building className="me-2 text-primary" />
                          Fournisseur
                        </h5>
                        <div className="mb-2">
                          <small className="text-muted d-block">Nom</small>
                          <strong>{selectedMethod.fournisseur}</strong>
                        </div>
                        {selectedMethod.contactFournisseur && (
                          <div>
                            <small className="text-muted d-block">Contact</small>
                            <strong>{selectedMethod.contactFournisseur}</strong>
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                  
                  <Col md={4}>
                    {/* Statistiques */}
                    <Card className="border-0 shadow-sm mb-3">
                      <Card.Body>
                        <h5 className="mb-3 d-flex align-items-center">
                          <Activity className="me-2 text-primary" />
                          Statistiques
                        </h5>
                        <div className="mb-2">
                          <small className="text-muted d-block">Volume mensuel</small>
                          <strong className="fs-5">{formatCurrency(selectedMethod.volumeMensuel)}</strong>
                        </div>
                        <div className="mb-2">
                          <small className="text-muted d-block">Transactions mensuelles</small>
                          <strong className="fs-5">{selectedMethod.nombreTransactions.toLocaleString()}</strong>
                        </div>
                        <div className="mb-2">
                          <small className="text-muted d-block">Taux de succès</small>
                          <PerformanceGauge value={selectedMethod.tauxSuccess} />
                        </div>
                      </Card.Body>
                    </Card>

                    {/* Tarification */}
                    <Card className="border-0 shadow-sm mb-3">
                      <Card.Body>
                        <h5 className="mb-3 d-flex align-items-center">
                          <Percent className="me-2 text-primary" />
                          Tarification
                        </h5>
                        <div className="mb-2">
                          <small className="text-muted d-block">Commission</small>
                          <strong className="fs-5 text-warning">{selectedMethod.commission}%</strong>
                        </div>
                        <div className="mb-2">
                          <small className="text-muted d-block">Frais fixes</small>
                          <strong className="fs-5">{formatCurrency(selectedMethod.fraisFixe)}</strong>
                        </div>
                        <div className="mb-2">
                          <small className="text-muted d-block">Délai de règlement</small>
                          <strong className="fs-5">{selectedMethod.delaiReglement} jours</strong>
                        </div>
                        <div>
                          <small className="text-muted d-block">Plage acceptée</small>
                          <div className="d-flex justify-content-between">
                            <small>Min: {formatCurrency(selectedMethod.seuilMinimum)}</small>
                            <small>Max: {formatCurrency(selectedMethod.seuilMaximum)}</small>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>

                   
                  </Col>
                </Row>
              </Modal.Body>
              
              <Modal.Footer className="border-0 pt-0">
                <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>
                  Fermer
                </Button>
                <Button variant="warning" onClick={() => {
                  setShowDetailsModal(false);
                  editMethod(selectedMethod);
                }}>
                  <Pencil className="me-2" />
                  Modifier
                </Button>
              </Modal.Footer>
            </>
          )}
        </Modal>

        {/* Modal de création */}
        <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <PlusCircle className="text-success me-2" />
              Nouveau Moyen de Paiement
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Code *</Form.Label>
                    <Form.Control
                      type="text"
                      name="code"
                      value={formData.code}
                      onChange={handleFormChange}
                      placeholder="Ex: CB_VISA"
                    />
                    <Form.Text className="text-muted">Code unique d'identification</Form.Text>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Nom *</Form.Label>
                    <Form.Control
                      type="text"
                      name="nom"
                      value={formData.nom}
                      onChange={handleFormChange}
                      placeholder="Ex: Carte VISA"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Type</Form.Label>
                    <Form.Select
                      name="type"
                      value={formData.type}
                      onChange={handleFormChange}
                    >
                      {methodTypes.filter(t => t.value !== 'all').map(type => (
                        <option key={type.value} value={type.value}>{type.label}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Catégorie</Form.Label>
                    <Form.Select
                      name="categorie"
                      value={formData.categorie}
                      onChange={handleFormChange}
                    >
                      {categories.filter(c => c.value !== 'all').map(cat => (
                        <option key={cat.value} value={cat.value}>{cat.label}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Statut</Form.Label>
                    <Form.Select
                      name="statut"
                      value={formData.statut}
                      onChange={handleFormChange}
                    >
                      {statuses.filter(s => s.value !== 'all').map(status => (
                        <option key={status.value} value={status.value}>{status.label}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Commission (%)</Form.Label>
                    <Form.Control
                      type="number"
                      name="commission"
                      value={formData.commission}
                      onChange={handleFormChange}
                      step="0.1"
                      min="0"
                      max="100"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Délai de règlement (jours)</Form.Label>
                    <Form.Control
                      type="number"
                      name="delaiReglement"
                      value={formData.delaiReglement}
                      onChange={handleFormChange}
                      min="0"
                      max="30"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Frais fixes ({defaultCurrency})</Form.Label>
                    <Form.Control
                      type="number"
                      name="fraisFixe"
                      value={formData.fraisFixe}
                      onChange={handleFormChange}
                      min="0"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Seuil minimum ({defaultCurrency})</Form.Label>
                    <Form.Control
                      type="number"
                      name="seuilMinimum"
                      value={formData.seuilMinimum}
                      onChange={handleFormChange}
                      min="0"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Seuil maximum ({defaultCurrency})</Form.Label>
                    <Form.Control
                      type="number"
                      name="seuilMaximum"
                      value={formData.seuilMaximum}
                      onChange={handleFormChange}
                      min="0"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Disponibilité</Form.Label>
                <div className="d-flex gap-2">
                  {availabilityOptions.map(option => (
                    <Form.Check
                      key={option.value}
                      type="checkbox"
                      id={`disponibilite-${option.value}`}
                      label={
                        <span className="d-flex align-items-center">
                          {option.icon} <span className="ms-1">{option.label}</span>
                        </span>
                      }
                      name="disponibilite"
                      value={option.value}
                      checked={formData.disponibilite.includes(option.value)}
                      onChange={handleFormChange}
                    />
                  ))}
                </div>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="description"
                  value={formData.description}
                  onChange={handleFormChange}
                  placeholder="Description détaillée du moyen de paiement..."
                />
              </Form.Group>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Fournisseur</Form.Label>
                    <Form.Control
                      type="text"
                      name="fournisseur"
                      value={formData.fournisseur}
                      onChange={handleFormChange}
                      placeholder="Ex: VISA International"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Contact fournisseur</Form.Label>
                    <Form.Control
                      type="text"
                      name="contactFournisseur"
                      value={formData.contactFournisseur}
                      onChange={handleFormChange}
                      placeholder="Ex: contact@visa.com"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
              <X className="me-2" />
              Annuler
            </Button>
            <Button variant="success" onClick={handleCreateMethod}>
              <PlusCircle className="me-2" />
              Créer
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal d'édition */}
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <Pencil className="text-warning me-2" />
              Modifier le Moyen de Paiement
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="code"
                      value={formData.code}
                      onChange={handleFormChange}
                      disabled
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Nom *</Form.Label>
                    <Form.Control
                      type="text"
                      name="nom"
                      value={formData.nom}
                      onChange={handleFormChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Type</Form.Label>
                    <Form.Select
                      name="type"
                      value={formData.type}
                      onChange={handleFormChange}
                    >
                      {methodTypes.filter(t => t.value !== 'all').map(type => (
                        <option key={type.value} value={type.value}>{type.label}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Catégorie</Form.Label>
                    <Form.Select
                      name="categorie"
                      value={formData.categorie}
                      onChange={handleFormChange}
                    >
                      {categories.filter(c => c.value !== 'all').map(cat => (
                        <option key={cat.value} value={cat.value}>{cat.label}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Statut</Form.Label>
                    <Form.Select
                      name="statut"
                      value={formData.statut}
                      onChange={handleFormChange}
                    >
                      {statuses.filter(s => s.value !== 'all').map(status => (
                        <option key={status.value} value={status.value}>{status.label}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Commission (%)</Form.Label>
                    <Form.Control
                      type="number"
                      name="commission"
                      value={formData.commission}
                      onChange={handleFormChange}
                      step="0.1"
                      min="0"
                      max="100"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Délai de règlement (jours)</Form.Label>
                    <Form.Control
                      type="number"
                      name="delaiReglement"
                      value={formData.delaiReglement}
                      onChange={handleFormChange}
                      min="0"
                      max="30"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Frais fixes ({defaultCurrency})</Form.Label>
                    <Form.Control
                      type="number"
                      name="fraisFixe"
                      value={formData.fraisFixe}
                      onChange={handleFormChange}
                      min="0"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Seuil minimum ({defaultCurrency})</Form.Label>
                    <Form.Control
                      type="number"
                      name="seuilMinimum"
                      value={formData.seuilMinimum}
                      onChange={handleFormChange}
                      min="0"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Seuil maximum ({defaultCurrency})</Form.Label>
                    <Form.Control
                      type="number"
                      name="seuilMaximum"
                      value={formData.seuilMaximum}
                      onChange={handleFormChange}
                      min="0"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Disponibilité</Form.Label>
                <div className="d-flex gap-2">
                  {availabilityOptions.map(option => (
                    <Form.Check
                      key={option.value}
                      type="checkbox"
                      id={`edit-disponibilite-${option.value}`}
                      label={
                        <span className="d-flex align-items-center">
                          {option.icon} <span className="ms-1">{option.label}</span>
                        </span>
                      }
                      name="disponibilite"
                      value={option.value}
                      checked={formData.disponibilite.includes(option.value)}
                      onChange={handleFormChange}
                    />
                  ))}
                </div>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="description"
                  value={formData.description}
                  onChange={handleFormChange}
                />
              </Form.Group>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Fournisseur</Form.Label>
                    <Form.Control
                      type="text"
                      name="fournisseur"
                      value={formData.fournisseur}
                      onChange={handleFormChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Contact fournisseur</Form.Label>
                    <Form.Control
                      type="text"
                      name="contactFournisseur"
                      value={formData.contactFournisseur}
                      onChange={handleFormChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              <X className="me-2" />
              Annuler
            </Button>
            <Button variant="warning" onClick={handleUpdateMethod}>
              <Check className="me-2" />
              Enregistrer
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de suppression */}
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <ExclamationCircle className="text-warning me-2" />
              Confirmer la suppression
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center">
              <Trash className="display-4 text-danger mb-3" size={48} />
              <h5>Êtes-vous sûr de vouloir supprimer ce moyen de paiement ?</h5>
              {selectedMethod && (
                <div className="mt-3 p-3 bg-light rounded">
                  <strong>{selectedMethod.nom}</strong>
                  <div className="mt-2">
                    <small className="text-muted d-block">Code: {selectedMethod.code}</small>
                    <small className="text-muted d-block">Type: {methodTypes.find(t => t.value === selectedMethod.type)?.label}</small>
                    <small className="text-muted d-block">Volume: {formatCurrency(selectedMethod.volumeMensuel)}</small>
                  </div>
                </div>
              )}
              <p className="text-muted mt-3">
                Cette action est irréversible. Les transactions associées seront conservées.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              <X className="me-2" />
              Annuler
            </Button>
            <Button variant="danger" onClick={confirmDeleteMethod}>
              <Trash className="me-2" />
              Supprimer
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de suppression multiple */}
        <Modal show={showBulkDeleteModal} onHide={() => setShowBulkDeleteModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <ExclamationCircle className="text-warning me-2" />
              Confirmer la suppression multiple
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="text-center">
              <Trash className="display-4 text-danger mb-3" size={48} />
              <h5>Supprimer {selectedMethods.length} moyen(s) de paiement ?</h5>
              <p className="text-muted mt-3">
                Vous êtes sur le point de supprimer définitivement {selectedMethods.length} moyen(s) de paiement.
                <br />
                <strong>Cette action est irréversible.</strong>
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowBulkDeleteModal(false)}>
              <X className="me-2" />
              Annuler
            </Button>
            <Button variant="danger" onClick={handleConfirmBulkDelete}>
              <Trash className="me-2" />
              Supprimer {selectedMethods.length} moyen(s)
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal d'export */}
        <Modal show={showExportModal} onHide={() => setShowExportModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <Download className="text-primary me-2" />
              Exporter les moyens de paiement
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-4">
                <Form.Label className="fw-bold mb-3">Format d'export</Form.Label>
                <div className="d-flex flex-wrap gap-2">
                  <Button
                    variant="outline-danger"
                    onClick={() => confirmExportReports('pdf')}
                    className="d-flex align-items-center"
                  >
                    <Download className="me-2" />
                    PDF
                  </Button>
                  <Button
                    variant="outline-success"
                    onClick={() => confirmExportReports('excel')}
                    className="d-flex align-items-center"
                  >
                    <Download className="me-2" />
                    Excel
                  </Button>
                  <Button
                    variant="outline-primary"
                    onClick={() => confirmExportReports('csv')}
                    className="d-flex align-items-center"
                  >
                    <Download className="me-2" />
                    CSV
                  </Button>
                  <Button
                    variant="outline-secondary"
                    onClick={() => confirmExportReports('json')}
                    className="d-flex align-items-center"
                  >
                    <Download className="me-2" />
                    JSON
                  </Button>
                </div>
              </Form.Group>
              
              <Form.Group className="mb-3">
                <Form.Label>Moyens à exporter</Form.Label>
                <div className="p-3 bg-light rounded">
                  {selectedMethods.length > 0 ? (
                    <div>
                      <small className="text-muted d-block">Export des moyens sélectionnés:</small>
                      <strong>{selectedMethods.length} moyen(s) sélectionné(s)</strong>
                    </div>
                  ) : (
                    <div>
                      <small className="text-muted d-block">Export des moyens filtrés:</small>
                      <strong>{filteredAndSortedItems.length} moyen(s) au total</strong>
                    </div>
                  )}
                </div>
              </Form.Group>
              
              <Alert variant="info" className="mt-3">
                <InfoCircle className="me-2" />
                <small>
                  <strong>PDF:</strong> Format optimisé pour l'impression<br />
                  <strong>Excel:</strong> Format éditable avec statistiques<br />
                  <strong>CSV:</strong> Format simple pour traitement de données<br />
                  <strong>JSON:</strong> Format pour développeurs/API
                </small>
              </Alert>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowExportModal(false)}>
              <X className="me-2" />
              Annuler
            </Button>
            <Button variant="primary" onClick={() => confirmExportReports('pdf')}>
              <Download className="me-2" />
              Exporter en PDF
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal de statistiques */}
        <Modal show={showStatsModal} onHide={() => setShowStatsModal(false)} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <Activity className="text-primary me-2" />
              Statistiques des Moyens de Paiement
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <Card className="border-0 shadow-sm mb-3">
                  <Card.Body>
                    <h5 className="mb-3">Répartition par Type</h5>
                    <div>
                      {methodTypes.filter(t => t.value !== 'all').map(type => {
                        const count = paymentMethods.filter(m => m.type === type.value).length;
                        const percentage = (count / paymentMethods.length) * 100;
                        return (
                          <div key={type.value} className="mb-2">
                            <div className="d-flex justify-content-between mb-1">
                              <span className="d-flex align-items-center">
                                <span className={`text-${type.color} me-2`}>{type.icon}</span>
                                <span>{type.label}</span>
                              </span>
                              <span className="fw-bold">{count} ({percentage.toFixed(1)}%)</span>
                            </div>
                            <ProgressBar now={percentage} variant={type.color} style={{ height: '6px' }} />
                          </div>
                        );
                      })}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              
              <Col md={6}>
                <Card className="border-0 shadow-sm mb-3">
                  <Card.Body>
                    <h5 className="mb-3">Répartition par Statut</h5>
                    <div>
                      {statuses.filter(s => s.value !== 'all').map(status => {
                        const count = paymentMethods.filter(m => m.statut === status.value).length;
                        const percentage = (count / paymentMethods.length) * 100;
                        return (
                          <div key={status.value} className="mb-2">
                            <div className="d-flex justify-content-between mb-1">
                              <span>
                                <Badge bg={status.color} className="me-2">{status.label}</Badge>
                              </span>
                              <span className="fw-bold">{count} ({percentage.toFixed(1)}%)</span>
                            </div>
                            <ProgressBar now={percentage} variant={status.color} style={{ height: '6px' }} />
                          </div>
                        );
                      })}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            
            <Row>
              <Col md={12}>
                <Card className="border-0 shadow-sm">
                  <Card.Body>
                    <h5 className="mb-3">Top 5 des Moyens par Volume</h5>
                    <div>
                      {[...paymentMethods]
                        .sort((a, b) => b.volumeMensuel - a.volumeMensuel)
                        .slice(0, 5)
                        .map((method, index) => {
                          const percentage = (method.volumeMensuel / globalStats.totalVolume) * 100;
                          return (
                            <div key={method.id} className="mb-3">
                              <div className="d-flex justify-content-between mb-1">
                                <span>
                                  <strong>{index + 1}. {method.nom}</strong>
                                  <small className="text-muted ms-2">({method.code})</small>
                                </span>
                                <span className="fw-bold">{formatCurrency(method.volumeMensuel)}</span>
                              </div>
                              <div className="d-flex justify-content-between mb-1">
                                <small className="text-muted">
                                  {method.nombreTransactions.toLocaleString()} transactions • {method.tauxSuccess}% succès
                                </small>
                                <small className="text-muted">{percentage.toFixed(1)}% du total</small>
                              </div>
                              <ProgressBar 
                                now={percentage} 
                                variant={index === 0 ? 'primary' : index === 1 ? 'success' : index === 2 ? 'info' : 'secondary'}
                                style={{ height: '8px' }}
                              />
                            </div>
                          );
                        })}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowStatsModal(false)}>
              Fermer
            </Button>
            <Button variant="primary" onClick={() => {
              setShowStatsModal(false);
              confirmExportReports('pdf');
            }}>
              <Download className="me-2" />
              Exporter les statistiques
            </Button>
          </Modal.Footer>
        </Modal>

        <Footer />
      </div>

      <style>{`
        .main-app {
          background-color: #f8f9fa;
          min-height: calc(100vh - 60px);
        }
        
        .icon-container {
          width: 50px;
          height: 50px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .stats-progress {
          height: 6px;
          border-radius: 3px;
        }
        
        .modal-details .modal-header {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }
        
        .breadcrumb {
          background: transparent;
          padding: 0;
          margin-bottom: 0.5rem;
        }
        
        .breadcrumb-item a {
          color: var(--bs-primary);
          text-decoration: none;
        }
        
        .breadcrumb-item.active {
          color: var(--bs-secondary);
        }
        
        .main-title {
          color: var(--bs-dark);
          font-weight: 600;
        }
        
        .stats-card {
          position: relative;
        }
        
        .card-gradient {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 4px;
        }
        
        .table tbody tr:hover {
          background-color: rgba(0, 123, 255, 0.05);
        }
        
        @media (max-width: 768px) {
          .main-app {
            padding: 1rem !important;
          }
          
          .d-flex.justify-content-between {
            flex-direction: column;
            gap: 1rem;
          }
          
          .d-flex.gap-2 {
            flex-wrap: wrap;
          }
          
          .table-responsive {
            font-size: 0.875rem;
          }
          
          .btn-group {
            flex-wrap: wrap;
          }
        }
      `}</style>
    </React.Fragment>
  );
}